import React, { useMemo } from 'react';
import classes from './Reports.module.css';
import { Tabs } from '../../components/UI/Tabs/Tabs';
import Consultations from '../Consultations/Consultations';
import Diagnostics from '../Diagnostics/Diagnostics';
import { useAppSelector } from '../../store/store';
import { IAccountInfo, selectAccountInfo } from '../../store/slices/auth';
import { useSearchParams } from 'react-router-dom';

const CONSULTATION_TAB = {
  tabName: 'schedule.consultations',
  tabIndex: 1,
};
const DIAGNOSTIC_TAB = {
  tabName: 'schedule.diagnostics',
  tabIndex: 0,
};

const Reports: React.FC = () => {
  const accountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  const [searchParams] = useSearchParams();
  const tabIdx = Number(searchParams.get('tabIdx')) || 0;
  const [selectedTabIdx, setSelectedTabIdx] = React.useState<number>(
    !accountInfo.serves_consultations && !accountInfo.serves_diagnostics ? -1 : tabIdx
  );

  const TABS: {
    tabName: string;
    tabIndex: number;
  }[] = useMemo(() => {
    if (accountInfo.serves_consultations && accountInfo.serves_diagnostics) {
      setSelectedTabIdx(0);
      return [DIAGNOSTIC_TAB, CONSULTATION_TAB];
    }
    if (accountInfo.serves_consultations) {
      setSelectedTabIdx(1);
      return [CONSULTATION_TAB];
    }
    if (accountInfo?.serves_diagnostics) {
      setSelectedTabIdx(0);
      return [DIAGNOSTIC_TAB];
    }
    return [];
  }, [accountInfo]);

  return (
    <div className={classes.container}>
      <div className={classes.tabsContainer}>
        <Tabs tabs={TABS} selectedTabIdx={selectedTabIdx} setSelectedTabIdx={setSelectedTabIdx} />
      </div>
      <div className={classes.content}>
        {selectedTabIdx === 0 && <Diagnostics hideHeader />}
        {selectedTabIdx === 1 && <Consultations hideHeader />}
      </div>
    </div>
  );
};

export { Reports };
